export default "/images/vendor/@coreui/icons/svg/flag/cif-nu.svg?bad2f76fe53cc9483300e911f9e362c1";